<template>
  <section>
    <el-form
      ref="send-form"
      :rules="rules"
      :model="sendFormData">
      <div class="plan-header">
        <div class="info flex">
          <h3>{{isEmail}}</h3>
        </div>
      </div>
      <template v-if="has_share&&showReferrer">
        <div class="form-item">
          <span class="mg-l-28">Referrer</span>
          <el-form-item >
            <div class="flex-align-center">
              <v-checkbox
                v-model="sendFormData.referrer_send"
                :is-boolean="false"
                class="mg-r-15"></v-checkbox>
              <v-input
                :value="referSendValue"
                disabled
              />
            </div>
          </el-form-item>

        </div>
        <div class="form-item">
          <el-form-item
            prop="referrer_content"
            :rules="rules.input">
            <v-input
              v-model="sendFormData.referrer_content"
              :disabled="sendFormData.referrer_send==0"
              type="textarea"
              :rows="4" />
          </el-form-item>
        </div>
      </template>
      <div class="form-item">
        <span>Customer</span>
        <div>
          <div class="flex-align-center">
            <v-checkbox
              v-if="isFina"
              v-model="sendFormData.customer_send"
              :is-boolean="false"
              class="mg-r-15"></v-checkbox>
            <v-input
              :value="customerSendValue"
              disabled
            />
          </div>
        </div>
      </div>
      <div
        v-if="emailListTitle"
        class="form-item">
        <span>Email list title</span>
        <div>
          <span>{{emailListTitle}}</span>
        </div>
      </div>
      <div
        v-if="emailTitle"
        class="form-item">
        <span>Title</span>
        <div>
          <span>{{emailTitle}}</span>
        </div>
      </div>
      <div class="form-item">
        <span>Content</span>
        <el-form-item prop="content">
          <v-input
            v-model="sendFormData.content"
            type="textarea"
            :disabled="isFina?sendFormData.customer_send==0:false"
            :rows="4" />
        </el-form-item>
      </div>
    </el-form>
    <div class="flex-sb-center">
      <div>
        <v-button @click="onCancel">Cancel</v-button>
      </div>
      <div>
        <v-button @click="onSkip">Skip</v-button>
        <v-button
          type="success"
          :disabled="isFina&&(!sendFormData.referrer_send&&!sendFormData.customer_send)"
          @click="onSend">Send</v-button>
      </div>
    </div>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    },
    initReferrerContent: {
      type: String,
      default: ''
    },
    emailListTitle: {
      type: String,
      default: ''
    },
    emailTitle: {
      type: String,
      default: ''
    },
    isFina:{
      type: Boolean,
      default: false
    },
    isIssued:{
      type: Boolean,
      default: false
    },
    showReferrer:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: '',
        referrer_content:'',
        customer_send:0,
        referrer_send:0,
      }
    }
  },
  computed:{
    has_share(){
      let {referrer_id} = this.form||{}
      return  referrer_id>0
      return JSON.stringify(this.referrer) != '{}'&&JSON.stringify(this.referrer) != '[]'
    },
    referrer(){
      let {referrer={}} = this.form||{}
      return referrer||{}
    },
    referSendValue(){
      let {isrd_nm,send_mobile,send_email,identity} = this.referrer||{}
      if(this.isIssued)
        return `${isrd_nm} - ${send_mobile}`
      return `${isrd_nm} - ${identity==1?send_mobile:send_email}`
    },
    customerSendValue(){
      let {cust_typ,customer,contact_email,email,mobile_no,isrd_nm} = this.form||{}
      if(cust_typ==1||!this.isCompany){
        let name = customer.isrd_nm||isrd_nm?`${customer.isrd_nm||isrd_nm} - `:''
        return `${name||isrd_nm} ${mobile_no}`
      }else  return contact_email||email

    },
    isEmail(){
      let {customer={},identity,id_type} = this.form||{}
      return identity==2||customer.identity==2||id_type==3?'Send Email':'Send SMS'
    },
    isCompany(){
      let {customer={},identity,id_type} = this.form||{}
      return identity==2||customer.identity==2||id_type == 3
    }
  },
  watch: {
    initContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && !this.sendFormData.content) {
          this.sendFormData.content = val
          if(!this.initReferrerContent)
            this.sendFormData.referrer_content = val
        }
      }
    },
    initReferrerContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && !this.sendFormData.referrer_content) {
          this.sendFormData.referrer_content = val
        }
      }
    },
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    onCancel() {
      this.$emit('cancel')
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          if(!this.isFina){
            this.sendFormData.customer_send = 1
          }
          this.$emit('send', this.sendFormData)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.$emit('skip')
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 1px solid #E1E4E8;
    margin: -15px -15px 15px;
    padding: 15px 15px 0px;
  }
      h3 {
        padding-bottom: 10px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
    }
</style>
